export const isPremOrganizationAdmin = (
  member: {
    idPremOrgsAdmin?: Array<string> | null;
  },
  idOrganization: string,
): boolean => {
  return !!member.idPremOrgsAdmin?.includes(idOrganization);
};
